// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"ea2b5880","55":"c110436f","98":"67938618","126":"cfdbc1ae","147":"ec36817b","171":"7855f65a","388":"8e17e35b","466":"21045d01","494":"2e525c16","594":"2a11b63e","780":"574060b4"}[chunkId] + ".chunk.js";
};